import { EntityModel } from '@/interfaces'
import {
  ALL_TRAVEL_TYPES_QUERY,
  CREATE_TRAVEL_TYPE_MUTATION,
  DELETE_TRAVEL_TYPE_MUTATION,
  FORCE_DELETE_TRAVEL_TYPE_MUTATION,
  SINGLE_TRAVEL_TYPE_QUERY,
  UPDATE_TRAVEL_TYPE_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const travelTypeModel: EntityModel = {
  name: 'travelType',
  namePlural: 'travelTypes',
  uniqueName: 'travelType',
  uniqueNamePlural: 'travelTypes',
  path: 'travel/travel_type',
  baseUrl: '/travel/travel_types',
  translationPrefix: 'entities:travelType.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_TRAVEL_TYPES_QUERY,
    getSingle: SINGLE_TRAVEL_TYPE_QUERY,
    create: CREATE_TRAVEL_TYPE_MUTATION,
    update: UPDATE_TRAVEL_TYPE_MUTATION,
    delete: DELETE_TRAVEL_TYPE_MUTATION,
    forceDelete: FORCE_DELETE_TRAVEL_TYPE_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:travelType.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    description: {
      name: 'description',
      label: 'entities:travelType.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    image: {
      name: 'image',
      label: 'entities:travelType.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelTypeModel
